import React from "react";
;
export var Tooltip = function (_a) {
    var title = _a.title, _b = _a.placement, placement = _b === void 0 ? 'right' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.isDisplayControlled, isDisplayControlled = _d === void 0 ? false : _d, _e = _a.show, show = _e === void 0 ? false : _e, children = _a.children;
    return (React.createElement("div", { className: "tooltip " + className + " " + placement + " " + (!title ? 'hide-tooltip' : '') },
        React.createElement("span", { className: "tooltip-title " + (!isDisplayControlled ? '' : show ? 'd-flex-imp' : 'd-none-imp') }, title),
        children));
};
